<template>
  <div class="side-controls">
    <div class="rotation-wrap">
      <v-slider
        :value="rotation"
        :min="rotationMin"
        :max="rotationMax"
        vertical
        hide-details
        thumb-label
        class="rotation-slider"
        @input="$emit('update:rotation', $event)"
      />
    </div>
    <div class="zoom-buttons">
      <v-btn small icon class="zoom-btn" @click="$emit('zoom-in')">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn small icon class="zoom-btn" @click="$emit('zoom-out')">
        <v-icon>mdi-minus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { ROTATION_MIN, ROTATION_MAX } from './constants'

export default {
  name: 'EngravingMaskSideControls',
  props: {
    rotation: { type: Number, default: 0 },
    rotationMin: { type: Number, default: ROTATION_MIN },
    rotationMax: { type: Number, default: ROTATION_MAX },
  },
}
</script>

<style scoped>
.side-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 56px;
}

.rotation-wrap {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rotation-wrap >>> .v-input__slot,
.rotation-wrap >>> .v-slider {
  height: 200px;
}

.rotation-wrap >>> .v-slider__thumb {
  left: 50% !important;
  transform: translate(-50%, 0);
}

.rotation-wrap >>> .v-slider.v-input--is-label-active .v-slider__thumb {
  transform: translate(-50%, -50%);
}

.zoom-buttons {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.zoom-btn {
  background: rgba(0, 0, 0, 0.6) !important;
  color: #fff !important;
  min-width: 36px !important;
  width: 36px;
  height: 36px;
}

.zoom-btn:hover {
  background: rgba(0, 0, 0, 0.8) !important;
}
</style>
